/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import ButtonGroup from '@/components/ButtonGroup';
import {
  LinkIcon,
  PageModeIcon,
  PresentationModeIcon,
} from '@/icons';
import { LeftArrowIcon } from '@/icons/LeftArrowIcon';
import { RightArrowIcon } from '@/icons/RightArrowIcon';
import {
  DisplayTypes,
  PageCanvasModel,
  PageNavigationDirection,
} from '@/types';
import './index.scss';
import { PageCanvasService } from '@/database/smartBookModelService';
interface SideToolsProps {
  bookId: number;
  side: 'left' | 'right';
  dispatch: (action: any) => void; // Replace `any` with the specific Redux action type if available
  handlePageChange: (params: PageNavigationDirection) => void; // Define the shape of `params` if known
  displayType: DisplayTypes;
  previousDisplayType: DisplayTypes;
  setDisplayType: (type: string) => void;
  setCurrentPageItem: (pageItem: any) => void; // Replace `any` with the specific type if known
  currentPage: PageCanvasModel; // Replace `any` with the specific type if known
  getBookPage: (params: any) => void; // Replace `any` with the specific type if known
  absolutePan: (direction: boolean) => boolean;
}

const SideTools: React.FC<SideToolsProps> = ({
  bookId,
  side,
  dispatch,
  displayType,
  previousDisplayType,
  setDisplayType,
  setCurrentPageItem,
  handlePageChange,
  currentPage,
}) => {
  const sideStyle: React.CSSProperties = {
    position: 'fixed',
    top: '50%',
    transform: 'translateY(-50%)',
    [side]: 0,
  };
  const [pageLink, setPageLink] = useState<Array<any> | null>(null); // Replace `any` with a specific type if known

  useEffect(() => {
    const navigation = currentPage.pageItems.filter(
      (x) => x.pageItemType === 170,
    );
    setPageLink(navigation.length > 0 ? navigation : null);
  }, [currentPage]);

  const changeMode = async () => {
    switch (displayType) {
      case DisplayTypes.Page:
        if (currentPage.pageItems?.length > 0) {
          const pageItem = await PageCanvasService.getPageItemFromId(
            bookId,
            currentPage.canvasWidth,
            currentPage.canvasHeight,
            currentPage,
            currentPage.pageItems[0].id,
          );
          dispatch(setCurrentPageItem(pageItem));
          dispatch(setDisplayType(DisplayTypes.PageItem));
        }
        break;
      case DisplayTypes.BlankPage:
        dispatch(setDisplayType(previousDisplayType));
        break;
      case DisplayTypes.PageItem:
      case DisplayTypes.CroppedArea:
        dispatch(setDisplayType(DisplayTypes.Page));
        break;
      default:
        dispatch(setDisplayType(DisplayTypes.Page));
        break;
    }
  };


  const buttons = [
    {
      id: 1,
      icon: <PageModeIcon className={undefined} />,
      onClick: changeMode,
    },
    {
      id: 2,
      icon: <PresentationModeIcon className={undefined} />,
      onClick: changeMode,
    },
  ];

  return (
    <div>
      <div className="side-tools" style={sideStyle}>
        {pageLink && side === 'left' && (
          <div className="page-links">
            {pageLink.map((link, index) => (
              <button
                key={`pageLink-${index}`}
                className="obro-btn obro-secondary-btn book-content-btn page-link-btn"
                onClick={() => link.linkToPageNo}
              >
                <span>
                  <LinkIcon className={undefined} />
                </span>
                <span>{link.title}</span>
              </button>
            ))}
          </div>
        )}
        <button
          className="margin-bottom-5"
          onClick={() => handlePageChange(PageNavigationDirection.Next)}
        >
          <RightArrowIcon className={undefined} />
        </button>
        <ButtonGroup
          buttons={buttons}
          direction="vertical"
          activeButtonId={displayType === DisplayTypes.Page ? 1 : 2}
        />
        <button
          className="margin-top-5"
          onClick={() => handlePageChange(PageNavigationDirection.Previous)}
        >
          <LeftArrowIcon className={undefined} />
        </button>
      </div>
    </div>
  );
};

export default SideTools;
